export default __webpack_public_path__ + "static/media/Төсвийн_шинэчлэл,_боловсролын_салбарын_бодлого,_эрх_зүйн_шинэчлэлийн.1566ff4a.png";